module.exports = __webpack_public_path__ + "img/studio图1.d8204184.png";